import { Link, Navigate, useLocation, useSearchParams } from "react-router-dom";
import SettingsNav from "../components/settings/SettingsNav.jsx";
import MyProfileSection from "../components/settings/MyProfileSection.jsx";
import Users from "./Settings/Users.jsx";
import { useProductMe } from "../hooks/useProductMe.js";

function LoadingShell() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "var(--bg-base)",
        color: "var(--text-secondary)",
      }}
    >
      Loading…
    </div>
  );
}

// Settings is NOT mounted under ProtectedOutlet. The post-recovery flow renders
// the "Set new password" panel here before Kratos has finalized the session — so
// we implement a softer guard inline: redirect to /login only when !authenticated
// AND not in recovery flow (?flow= query param). If you change auth routing
// patterns, verify the recovery → settings handoff still works.
export default function Settings() {
  const { me, loading } = useProductMe();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "profile";
  const flowFromUrl = searchParams.get("flow");
  const fromRecovery =
    Boolean(location.state?.fromRecovery) || Boolean(flowFromUrl?.trim());
  const isAdminOrOwner = Boolean(me?.user?.is_admin || me?.user?.is_owner);

  if (loading) return <LoadingShell />;
  if (!me?.authenticated && !fromRecovery) {
    return <Navigate to="/login" replace state={{ from: "/settings" }} />;
  }

  if (fromRecovery && tab === "users") {
    return <Navigate to={`/settings?tab=profile${flowFromUrl ? `&flow=${encodeURIComponent(flowFromUrl)}` : ""}`} replace state={location.state} />;
  }

  if (tab === "users" && !isAdminOrOwner) {
    return <Navigate to="/settings?tab=profile" replace />;
  }

  const activeTab = tab === "users" && isAdminOrOwner ? "users" : "profile";

  return (
    <div className="min-h-screen" style={{ background: "var(--bg-base)", color: "var(--text-primary)" }}>
      <div style={{ maxWidth: "960px", margin: "0 auto", padding: "32px 24px" }}>
        <Link to="/" style={{ fontSize: "13px", color: "var(--accent)", textDecoration: "none" }}>
          ← Back to projects
        </Link>
        <h1 style={{ fontSize: "24px", fontWeight: 700, margin: "16px 0 24px 0" }}>Settings</h1>

        <div
          className="grid gap-8"
          style={{ gridTemplateColumns: "minmax(160px, 200px) 1fr" }}
        >
          <SettingsNav showUsersTab={isAdminOrOwner} />
          <main>
            {activeTab === "users" ? (
              <Users />
            ) : (
              <MyProfileSection user={me.user} />
            )}
          </main>
        </div>
      </div>
    </div>
  );
}
